import { useNavigate, useParams } from 'react-router-dom'

import { FinanceGetDimensionValuesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

import DeleteDimensionValueModal from 'modules/finance/components/Dimensions/DeleteDimensionValueModal'

const DeleteValue = () => {
  const { company } = useCurrentSession()
  const { id, value_id } = useParams()

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const [fetch] = useLazyQuery(FinanceGetDimensionValuesDocument, {
    variables: {
      dimensionId: Number(id),
      tenant: { companyId: company.id },
    },
  })

  const onClose = (success?: boolean) => {
    if (success) {
      fetch()

      navigate(
        navigation.settings.finance.dimensions.dimension.fullPath({
          id: Number(id),
        })
      )
    } else {
      navigate(
        navigation.settings.finance.dimensions.dimension.values.fullPath({
          id: Number(id),
          value_id: Number(value_id),
        })
      )
    }
  }

  return <DeleteDimensionValueModal id={Number(value_id)} onClose={onClose} />
}

export default DeleteValue
